/** Tipos de movimentação da linha do contrato. */
export enum ERowMovementTypes {
  CONTRACT = "Contrato",
  ADDITIVE = "Aditivo",
  CANCELLATION = "Distrato",
  READJUSTMENT = "Reajuste",
  UPDATED = "Alterado",
  EDIT_DESCRIPTION = "AlteradaDescricao",
}
